export default "__VITE_ASSET__DQEmoqop__"